(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(42859);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/modules/auth/components/Header/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  margin-bottom: ",
        ";\n  margin-top: -",
        ";\n\n  h2 {\n    color: ",
        ";\n    font-weight: 700;\n    font-size: 30px;\n    font-weight: 700;\n    text-align: center;\n\n    & + p {\n      margin-top: ",
        ";\n    }\n  }\n\n  p {\n    color: ",
        ";\n    font-size: 16px;\n    text-align: center;\n    line-height: 24px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-a26e7196-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.spacing.xs;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xxs;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
});

;// CONCATENATED MODULE: ./src/modules/auth/components/Header/index.tsx



const Header = (param)=>{
    let { title , subtitle , extraSubtitle  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: subtitle.split("\n").map((line)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            line,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    }, line))
            }),
            extraSubtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                children: extraSubtitle
            })
        ]
    });
};


/***/ }),

/***/ 77879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Link; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/modules/auth/components/Link/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-right: auto;\n\n  color: ",
        ";\n\n  transition: all 0.3s;\n\n  span {\n    font-size: 14px;\n    font-weight: 600;\n\n    > * {\n      color: ",
        ";\n    }\n  }\n\n  svg {\n    margin-right: ",
        ";\n    height: 18px;\n    width: 18px;\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  & + a,\n  & + button {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const Container = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
    componentId: "sc-a2acc475-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.secondary;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.secondary;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xs;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.sm;
});

;// CONCATENATED MODULE: ./src/modules/auth/components/Link/index.tsx


const Link = (param)=>{
    let { title , icon: Icon , href , target , rel , customContent , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        href: href,
        passHref: true,
        ...props,
        target: target,
        rel: rel,
        children: [
            !!Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
            customContent || /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: title
            })
        ]
    });
};


/***/ }),

/***/ 42859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/toast/dist/chunk-JFERWNZE.mjs
var chunk_JFERWNZE = __webpack_require__(9691);
// EXTERNAL MODULE: ./src/shared/utils/getValidationErrors.ts
var getValidationErrors = __webpack_require__(56461);
// EXTERNAL MODULE: ./src/shared/hooks/settings.tsx + 1 modules
var hooks_settings = __webpack_require__(51305);
// EXTERNAL MODULE: ./src/shared/hooks/modal.tsx + 1 modules
var modal = __webpack_require__(74369);
// EXTERNAL MODULE: ./src/shared/constants/routes.ts
var routes = __webpack_require__(224);
// EXTERNAL MODULE: ./src/shared/components/Form/Input/index.tsx
var Input = __webpack_require__(72169);
// EXTERNAL MODULE: ./src/shared/components/Form/FormGroup/index.tsx + 1 modules
var FormGroup = __webpack_require__(24293);
// EXTERNAL MODULE: ./src/shared/components/Form/Button/index.tsx + 1 modules
var Button = __webpack_require__(52409);
// EXTERNAL MODULE: ./src/modules/auth/hooks/auth.tsx + 1 modules
var auth = __webpack_require__(30317);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./src/modules/auth/components/RedirectToResaleModal/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .infos {\n    margin-bottom: 30px;\n    background-color: white;\n    border-radius: 6px;\n    padding: 18px;\n    font-weight: bold;\n    border: 1px solid #00000026;\n  }\n\n  h1 {\n    margin-top: 30px;\n    margin-bottom: 30px;\n  }\n\n  h2 {\n    margin-bottom: 30px;\n  }\n\n  img {\n    width: 100px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c400ab4-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/modules/auth/components/RedirectToResaleModal/index.tsx





const RedirectToResaleModal = (param)=>{
    let { redirectToDomain  } = param;
    const [count, setCount] = (0,react.useState)(5);
    const redirect = (0,react.useCallback)(()=>{
        window.open("".concat(redirectToDomain, "?autoSignOut=true"), "_self");
    }, [
        redirectToDomain
    ]);
    (0,react.useEffect)(()=>{
        const timer = setInterval(()=>{
            if (count > 0) {
                setCount((prevCount)=>prevCount - 1);
            } else {
                clearInterval(timer);
                redirect();
            }
        }, 1000);
        return ()=>clearInterval(timer);
    }, [
        count,
        redirect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "infos",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Ops, identificamos que voc\xea est\xe1 acessando o portal pelo link incorreto."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/images/redirect-icon.png",
                alt: "icon",
                width: 100,
                height: 100
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "".concat(redirectToDomain, "?autoSignOut=true"),
                children: redirectToDomain
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Voc\xea est\xe1 sendo redirecionado, por favor, aguarde..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Se voc\xea n\xe3o for redirecionado em 5 segundos, clique no bot\xe3o abaixo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                onClick: redirect,
                disabled: count !== 0,
                children: [
                    "Continuar ",
                    count > 0 ? "(".concat(count, " segundos)") : ""
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/modules/auth/components/Link/index.tsx + 1 modules
var Link = __webpack_require__(77879);
// EXTERNAL MODULE: ./src/modules/auth/components/Header/index.tsx + 1 modules
var Header = __webpack_require__(15601);
;// CONCATENATED MODULE: ./src/modules/auth/pages/SignIn/index.tsx

















const signInSchema = es/* object */.Ry().shape({
    email: es/* string */.Z_().email("e-mail inv\xe1lido").required("e-mail \xe9 obrigat\xf3rio"),
    password: es/* string */.Z_().required("senha \xe9 obrigat\xf3ria")
});
const SignIn = ()=>{
    const { colors  } = (0,styled_components_browser_esm/* useTheme */.Fg)();
    const { settings  } = (0,hooks_settings/* useSettings */.r)();
    const { signIn , setPhoneNumber  } = (0,auth/* useAuth */.aC)();
    const toast = (0,chunk_JFERWNZE/* useToast */.p)();
    const { openModal  } = (0,modal/* useModal */.d)();
    const [formData, setFormData] = (0,react.useState)({
        email: "",
        password: ""
    });
    const [formErrors, setFormErrors] = (0,react.useState)({});
    const [isSigning, setIsSigning] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setPhoneNumber("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChangeInput = (0,react.useCallback)((event)=>{
        const { name , value  } = event.target;
        if (formErrors[name]) {
            setFormErrors((prevState)=>({
                    ...prevState,
                    [name]: ""
                }));
        }
        setFormData((prevState)=>({
                ...prevState,
                [name]: value
            }));
    }, [
        formErrors
    ]);
    async function handleSignIn(event) {
        event.preventDefault();
        try {
            setIsSigning(true);
            const data = {
                ...formData,
                email: formData.email.trim()
            };
            await signInSchema.validate(data, {
                abortEarly: false
            });
            await signIn(data);
        } catch (error) {
            var _error_response, _error_response_data;
            const tag = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.tag;
            setIsSigning(false);
            if (tag === "incorrect_resale_domain") {
                var _error_response1, _error_response_data1, _error_response_data_content;
                let domain = error === null || error === void 0 ? void 0 : (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_data1 = _error_response1.data) === null || _error_response_data1 === void 0 ? void 0 : (_error_response_data_content = _error_response_data1.content) === null || _error_response_data_content === void 0 ? void 0 : _error_response_data_content.redirectToDomain;
                if (domain) {
                    if (domain.includes("www")) {
                        domain = domain.replace("www.", "");
                    }
                    openModal(RedirectToResaleModal, {
                        modalProps: {
                            closeOnClickOutside: false,
                            closeOnEsc: false,
                            shouldConfirm: false,
                            showHeader: false
                        },
                        props: {
                            redirectToDomain: error.response.data.content.redirectToDomain
                        }
                    });
                    return;
                }
            }
            if (error instanceof es/* ValidationError */.p8) {
                const validationErrors = (0,getValidationErrors/* getValidationErrors */.Z)(error);
                setFormErrors((prevState)=>({
                        ...prevState,
                        ...validationErrors
                    }));
                return;
            }
            toast({
                status: "error",
                isClosable: true,
                position: "top-right",
                ...tag === "user_inactive" ? {
                    title: error.response.data.message
                } : {
                    title: "Ops, ocorreu um erro ao fazer o login!",
                    description: "Parece que seu e-mail e/ou senha est\xe1(\xe3o) incorreto(s)."
                }
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSignIn,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                        title: "Seja bem vindo_",
                        subtitle: 'J\xe1 \xe9 cliente? Fa\xe7a login abaixo.\nN\xe3o tem senha? Use "esqueci a senha".'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                            name: "email",
                            placeholder: "E-mail",
                            autoComplete: "email",
                            value: formData.email,
                            error: formErrors.email,
                            onChange: handleChangeInput,
                            variant: "default"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                            name: "password",
                            autoComplete: "current-password",
                            type: "password",
                            placeholder: "Senha",
                            value: formData.password,
                            error: formErrors.password,
                            onChange: handleChangeInput,
                            variant: "default"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: routes/* routes.auth.forgotPassword */._.auth.forgotPassword,
                            title: "Esqueci a senha"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* FormGroup */.c, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                type: "submit",
                                isLoading: isSigning,
                                children: "Entrar"
                            }),
                            (settings === null || settings === void 0 ? void 0 : settings.registrationPageLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                type: "button",
                                variant: "outlined",
                                backgroundColor: "surface",
                                borderColor: "primary",
                                textColor: "primary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: settings.registrationPageLink,
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: "Ainda n\xe3o sou cliente"
                                })
                            })
                        ]
                    })
                ]
            }),
            (settings === null || settings === void 0 ? void 0 : settings.helpLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: settings.helpLink,
                target: "_blank",
                rel: "noreferrer",
                customContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    style: {
                        color: colors.onSurface
                    },
                    children: [
                        "D\xfavida sobre o cadastro? ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: "Clique aqui"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/index.tsx


const SignInPage = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignIn, {});
};
var __N_SSP = true;
/* harmony default export */ var pages = (SignInPage);


/***/ }),

/***/ 56461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getValidationErrors; }
/* harmony export */ });
function getValidationErrors(err) {
    const validationErrors = {};
    err.inner.forEach((error)=>{
        const splittedPath = error.path.split(".");
        if ((splittedPath === null || splittedPath === void 0 ? void 0 : splittedPath.length) === 2) {
            validationErrors[splittedPath[0]] = {
                ...validationErrors[splittedPath[0]],
                [splittedPath[1]]: error.message
            };
        } else {
            validationErrors[error.path] = error.message;
        }
    });
    return validationErrors;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [939,4231,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);